import { Box, Container, Grid } from "@mui/material";

import globalContext from '../../context/context'
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import WalletPrice from "../../utils/WalletPrice";
import { useTranslation } from "react-i18next";

const convertDate = (dateO) => {

    if(!dateO){
        return;
    }

    let finalDate = new Date();
    if (dateO?.toString() == dateO) {
        finalDate = new Date( dateO );
    } else {
        finalDate = new Date( dateO?.toISOString() )
    }

    finalDate = new Date( finalDate?.getTime() + (new Date().getTimezoneOffset()*-1*60000) );
    console.log('finalDate', finalDate, finalDate?.toISOString()?.substring(0, 19))
    return finalDate?.toISOString()?.substring(0, 19)?.split('T')?.join(' ');
}

function CartStepTwo() {

    const { t } = useTranslation();
    const { contextData: { details, cart, cartSum, transfer, parking, lounge, currency } } = useContext(globalContext);

    const getName = (type) => {

        if (type === 'parking' && parking && parking[0]) {
            return parking[0]?.name
        }

        if (type === 'transfer' && transfer && transfer[0]) {
            return transfer[0]?.name
        }

        if (type === 'lounge' && lounge && lounge[0]) {
            return lounge[0]?.name
        }

    }

    const getPrice = (type) => {

        if (type === 'parking' && parking && parking[0]) {
            return parking[0]?.priceInCurrency + " " + parking[0]?.currency
        }

        if (type === 'transfer' && transfer && transfer[0]) {
            return transfer[0]?.priceInCurrency + " " + transfer[0]?.currency
        }

        if (type === 'lounge' && lounge && lounge[0]) {
            return lounge[0]?.priceInCurrency + " " + lounge[0]?.currency
        }

    }

    const shouldType = (type) => {

        if (
            type === 'parking'
            &&
            parking && parking[0]
            &&
            !(cart?.directionFrom?.departureParking || cart?.directionTo?.departureParking)
        ) {
            return true;
        }

        if (
            type === 'transfer'
            && transfer && transfer[0]
            &&
            !(cart?.directionFrom?.arrivalTransfer
                || cart?.directionFrom?.departureTransfer
                || cart?.directionTo?.departureTransfer
                || cart?.directionTo?.arrivalTransfer)
        ) {
            return true;
        }

        if (
            type === 'lounge'
            && lounge && lounge[0]
            &&
            !(cart?.directionFrom?.departureLounge || cart?.directionTo?.departureLounge)
        ) {
            return true;
        }

        return false;

    }



    return (
        <>
            {cart?.id ? <Container disableGutters sx={{ pt: 4 }}>

                <Box sx={{ fontSize: 16, pb: 4 }}>
                    {t('cart.fillDetails')}
                </Box>

                <Grid spacing={2} container>
                    <Grid xs={12} md={6} item>
                        <Box sx={{ p: { xs: 2, md: 3 }, color: '#000', border: '2px solid #ea0089', borderRadius: '10px' }}>
                            <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.leadPassengerData')}</Box>
                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.surname')}</Grid>
                                <Grid xs={12} md={6} item>{details?.surname}</Grid>
                            </Grid>
                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.firstname')}</Grid>
                                <Grid xs={12} md={6} item>{details?.firstname}</Grid>
                            </Grid>

                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.email')}</Grid>
                                <Grid sx={{ wordBreak: 'break-all' }} xs={12} md={6} item>{details?.email}</Grid>
                            </Grid>

                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.phone')}</Grid>
                                <Grid xs={12} md={6} item>{details?.phone}</Grid>
                            </Grid>

                            <Box sx={{ pb: 1, pt: 5, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.flightData')}</Box>

                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightNumber')}</Grid>
                                <Grid xs={12} md={6} item>{details?.flightNumber}</Grid>
                            </Grid>

                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightArrival')}</Grid>
                                <Grid xs={12} md={6} item>{convertDate(details?.flightArrival)}</Grid>
                            </Grid>

                            <Grid direction="row"
                                sx={{ pt: 2 }}
                                justifyContent="flex-start"
                                alignItems="center" container>
                                <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightDeparture')}</Grid>
                                <Grid xs={12} md={6} item>{convertDate(details?.flightDeparture)}</Grid>
                            </Grid>


                            {details?.flightNumber2 && <>
                                <Box sx={{ pb: 1, pt: 5, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>Return</Box>
                                <Grid direction="row"
                                    sx={{ pt: 2 }}
                                    justifyContent="flex-start"
                                    alignItems="center" container>
                                    <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightNumber')}</Grid>
                                    <Grid xs={12} md={6} item>{details?.flightNumber2}</Grid>
                                </Grid>

                                <Grid direction="row"
                                    sx={{ pt: 2 }}
                                    justifyContent="flex-start"
                                    alignItems="center" container>
                                    <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightArrival')}</Grid>
                                    <Grid xs={12} md={6} item>{convertDate(details?.flightArrival2)}</Grid>
                                </Grid>

                                <Grid direction="row"
                                    sx={{ pt: 2 }}
                                    justifyContent="flex-start"
                                    alignItems="center" container>
                                    <Grid sx={{ fontWeight: '800' }} xs={12} md={6} item>{t('cart.flightDeparture')}</Grid>
                                    <Grid xs={12} md={6} item>{convertDate(details?.flightDeparture2)}</Grid>
                                </Grid>
                            </>}
                        </Box>
                    </Grid>
                    <Grid xs={12} md={6} item>
                        <Box sx={{ border: '2px solid #f6c3ca', borderRadius: '10px' }}>
                            <Box sx={{ p: { xs: 2, md: 4 }, color: '#000', background: '#f6c3ca', border: '2px solid #f6c3ca', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                <Box sx={{ pb: 1, fontWeight: 600, fontSize: 16, color: '#ea0089' }}>{t('cart.walletFunds')}: <WalletPrice /></Box>
                                <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                                    {cart?.directionFrom?.departureTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionFrom?.departureTransfer?.quantity} x {cart?.directionFrom?.departureTransfer?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureTransfer?.priceInCurrency} {cart?.directionFrom?.departureTransfer?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.arrivalTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionFrom?.arrivalTransfer?.quantity} x {cart?.directionFrom?.arrivalTransfer?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.arrivalTransfer?.priceInCurrency} {cart?.directionFrom?.arrivalTransfer?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureLounge && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionFrom?.departureLounge?.quantity} x {cart?.directionFrom?.departureLounge?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureLounge?.priceInCurrency} {cart?.directionFrom?.departureLounge?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureParking && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionFrom?.departureParking?.quantity} x {cart?.directionFrom?.departureParking?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureParking?.priceInCurrency} {cart?.directionFrom?.departureParking?.currency}</Grid>
                                    </Grid>}

                                    {cart?.directionTo?.departureTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionTo?.departureTransfer?.quantity} x {cart?.directionTo?.departureTransfer?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureTransfer?.priceInCurrency} {cart?.directionTo?.departureTransfer?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionTo?.arrivalTransfer && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionTo?.arrivalTransfer?.quantity} x {cart?.directionTo?.arrivalTransfer?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.arrivalTransfer?.priceInCurrency} {cart?.directionTo?.arrivalTransfer?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureLounge && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionTo?.departureLounge?.quantity} x {cart?.directionTo?.departureLounge?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureLounge?.priceInCurrency} {cart?.directionTo?.departureLounge?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureParking && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionTo?.departureParking?.quantity} x {cart?.directionTo?.departureParking?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureParking?.priceInCurrency} {cart?.directionTo?.departureParking?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionTo?.departureFastTrack && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionTo?.departureFastTrack?.quantity} x {cart?.directionTo?.departureFastTrack?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionTo?.departureFastTrack?.priceInCurrency} {cart?.directionTo?.departureFastTrack?.currency}</Grid>
                                    </Grid>}
                                    {cart?.directionFrom?.departureFastTrack && <Grid direction="row"
                                        justifyContent="space-between"
                                        sx={{ py: 0.5 }}
                                        alignItems="center" container>
                                        <Grid xs={8} item>{cart?.directionFrom?.departureFastTrack?.quantity} x {cart?.directionFrom?.departureFastTrack?.name}</Grid>
                                        <Grid xs={4} sx={{ textAlign: 'right' }} item>{cart?.directionFrom?.departureFastTrack?.priceInCurrency} {cart?.directionFrom?.departureFastTrack?.currency}</Grid>
                                    </Grid>}

                                </Box>
                            </Box>
                            <Box sx={{ px: { xs: 2, md: 4 }, py: 1, color: '#000' }}>
                                <Box sx={{ pt: 1, fontWeight: 900, fontSize: 16, color: '#000' }}>
                                    <Grid direction="row"
                                        justifyContent="space-between"
                                        alignItems="top" container>
                                        <Grid xs={7} item>
                                            {cartSum?.promotionInCurrency ? <>
                                                <small style={{ fontWeight: 'normal' }}>{t("cart.promotionDiscount")}</small>
                                                <br />
                                                {t("cart.totalPaid")}
                                            </> : <>
                                                {t("cart.totalPaid")}
                                            </>}
                                            {!!cartSum?.transactionFeeInCurrency && <>
                                                <br />
                                                <small style={{ fontWeight: 'normal' }}><strong>{cartSum?.transactionFeeInCurrency} {currency}</strong> {t("cart.transactionFee")}</small>
                                            </>}
                                        </Grid>
                                        <Grid xs={5} style={{ textAlign: 'right' }} item>

                                            {cartSum?.promotionInCurrency ? <>
                                                <small style={{ fontWeight: 'bold' }}>{cartSum?.promotionInCurrency} {currency}</small>
                                                <br />
                                                <small style={{ textDecoration: 'line-through', fontWeight: 'normal' }}>{cartSum?.priceInCurrency} {currency}</small> {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                            </> : <>
                                                {cartSum?.priceWithPromotionAndTransactionFeeInCurrency} {currency}
                                            </>}
                                            <br />
                                            <small style={{ fontWeight: 'normal' }}>{t("cart.vatIncl")}</small>
                                        </Grid>
                                    </Grid>

                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{ px: 0, py: 1, color: '#333' }}>
                            <Box sx={{ py: 2, fontWeight: 600, fontSize: 16 }}>
                                {[
                                    {
                                        name: 'parking',
                                        icon: '/images/parking.png'

                                    },
                                    {
                                        name: 'transfer',
                                        icon: '/images/fasttrack.png'

                                    },
                                    {
                                        name: 'lounge',
                                        icon: '/images/lounge.png'

                                    }
                                ].filter((t) => shouldType(t.name))
                                    .map((ex, exKey) => <Box key={exKey} sx={{
                                        border: '2px solid #ea0089',
                                        pl: 2,
                                        borderRadius: '10px',
                                        mt: 2,
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <Box sx={{ width: 'calc( 100% - 80px )' }}>
                                            <Grid direction="row"
                                                justifyContent="space-between"
                                                sx={{ py: 3, pr: 2 }}
                                                alignItems="center" container>
                                                <Grid xs={8} item>{getName(ex.name)}</Grid>
                                                <Grid xs={4} sx={{ fontWeight: 'normal', textAlign: 'right' }} item>{getPrice(ex.name)}</Grid>
                                            </Grid>
                                        </Box>
                                        <Box sx={{
                                            width: '80px',
                                            backgroundImage: `url('${ex.icon}')`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                        }}></Box>
                                    </Box>)}


                            </Box>
                        </Box>
                    </Grid>
                </Grid>

            </Container> : <>{t('cart.emptyCart')}</>}

        </>
    );
}

export default CartStepTwo;
